import api from "./Api";

class LicencaRecebivelService {
  GetLicencaRecebivel(payload) {
    return api.get("/v1/licencarecebivel/" + payload).then((response) => {
      return response.data;
    });
  }

  PostLicencaRecebivel(payload) {
    return api.post("/v1/licencarecebivel/", payload).then((response) => {
      return response.data;
    });
  }

  PutLicencaRecebivel(payload) {
    return api.put("/v1/licencarecebivel/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteLicencaRecebivel(payload) {
    return api.delete("/v1/licencarecebivel/" + payload).then((response) => {
      return response.data;
    });
  }

  GetLicencaRecebivelOData(payload) {
    return api.get("/OData/licencarecebivel" + payload).then((response) => {
      return response.data;
    });
  }

  PostGerarFaturaLicencas(payload) {
    return api
      .post("/v1/licencarecebivel/GerarFaturaLicencas?dataGeracao=" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarBoleto(payload) {
    return api
      .post("/v1/licencarecebivel/GerarBoleto/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarCobrancaImediata(payload) {
    return api
      .post("/v1/licencarecebivel/GerarCobrancaImediata/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetConsultaCobrancaImediata(payload) {
    return api
      .get("/v1/licencarecebivel/ConsultaCobrancaImediata/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostSolicitarMovimentacao(payload) {
    return api
      .post("/v1/licencarecebivel/SolicitarMovimentacao" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostBaixarBoleto(payload) {
    return api
      .post("/v1/licencarecebivel/BaixarBoleto/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarBoletoMP(payload) {
    return api
      .post("/v1/licencarecebivel/GerarBoletoMP/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGerarPIXMP(payload) {
    return api
      .post("/v1/licencarecebivel/GerarPIXMP/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetCobrancaMP(payload) {
    return api
      .get("/v1/licencarecebivel/CobrancaMP/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostMovimentacaoMP(payload) {
    return api
      .post("/v1/licencarecebivel/MovimentacaoMP" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new LicencaRecebivelService();
